import { SkillType } from '../enums/SkillsType';
import { VacancySkillModel } from './VacancySkill';

export interface VacancySkillsInfoModel {
  type?: SkillType;
  vacancy_id: string | null;
  skills: VacancySkillModel[] | null;
}
